<div class="row justify-content-center" style="padding-top:20%;">
  <div class="col-xl-6 text-center my-auto">
    <div class="fs-6 text-muted">
      Mastercup Online V.2
    </div>
  </div>
</div>
